// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\StudioTypesSection\\\\components\\\\StudiosSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\StudioTypesSection\\components\\StudiosSection.tsx");
  import.meta.hot.lastModified = "1757171103320.783";
}
// REMIX HMR END

import { SectionHeader } from "~/components/shared/SectionHeader";
import { Carousel } from "./Carousel";
import { StudioCard } from "./StudioCard";
export function StudiosSection({
  title,
  subtitle,
  items,
  isCarousel = false
}) {
  return <section className="relative w-full bg-white">
      <div className="mx-auto w-full max-w-[1328px] px-4 lg:px-14 py-14 lg:py-[120px]">
        <div className="flex flex-col gap-6 lg:gap-10">
          <div className="flex flex-col lg:flex-row lg:items-end gap-4 lg:gap-6">
            <SectionHeader eyebrow="STUDIO TYPES" title={title} className="flex-1 max-w-[991px]" />
          </div>

          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            {subtitle && <p className="text-body-3 lg:text-body-1 text-neutral-800 max-w-[763px]">
                {subtitle}
              </p>}
          </div>
        </div>

        {isCarousel ? <>
            {/* Mobile: Vertical layout */}
            <div className="mt-6 flex flex-col gap-6 lg:hidden">
              {items.map(item => <StudioCard key={item.id} image={item.image} title={item.title} description={item.description} href={item.href} />)}
            </div>
            {/* Desktop: Carousel */}
            <Carousel className="mt-6 hidden lg:block">
              {items.map(item => <StudioCard key={item.id} image={item.image} title={item.title} description={item.description} href={item.href} className="snap-start shrink-0 w-[426.67px]" />)}
            </Carousel>
          </> : <div className="mt-6 flex flex-col gap-6 lg:grid lg:grid-cols-1 md:lg:grid-cols-2 lg:grid-cols-3">
            {items.map(item => <StudioCard key={item.id} image={item.image} title={item.title} description={item.description} href={item.href} />)}
          </div>}
      </div>
    </section>;
}
_c = StudiosSection;
var _c;
$RefreshReg$(_c, "StudiosSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;